'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconArrowButtonLeft2 = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M21.016.531A2 2 0 0 0 19 .563L2.929 10.288a2 2 0 0 0 0 3.422L19 23.436a2 2 0 0 0 3.035-1.711V2.274A2 2 0 0 0 21.016.531z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M20.068 23.226c-.274 0-.543-.075-.777-.217L3.222 13.284a1.487 1.487 0 0 1-.68-.924 1.49 1.49 0 0 1 .68-1.643L19.291.992c.233-.142.501-.217.774-.217a1.5 1.5 0 0 1 1.503 1.5v19.452a1.496 1.496 0 0 1-1.5 1.499zm-.001-21.451a.5.5 0 0 0-.258.072L3.74 11.572a.496.496 0 0 0 0 .856l16.069 9.726a.5.5 0 0 0 .759-.427V2.275a.497.497 0 0 0-.501-.5z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M20.247 23.25c-.263 0-.523-.07-.75-.202L2.256 13.29a1.471 1.471 0 0 1-.57-.572 1.47 1.47 0 0 1-.13-1.124c.108-.38.358-.695.703-.887L19.503.947c.216-.125.466-.194.722-.198.412.002.789.152 1.068.423.288.279.45.653.456 1.054v19.537a1.52 1.52 0 0 1-.202.74 1.505 1.505 0 0 1-1.3.747zm-.005-1.503l.006-19.498-17.23 9.752 17.224 9.746z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconArrowButtonLeft2.displayName = 'IconArrowButtonLeft2';
exports.default = IconArrowButtonLeft2;